import { MinusOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Form, Input, Select } from 'antd'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { SiteVisitRuleBean, TrackerBean } from 'src/api/api'
import { formDataLoader, FormDataType } from 'src/util/FormDataLoader'
import { enumView } from 'src/util/Util'
import './style.css'

const Option = Select.Option
const FormItem = Form.Item

const UrlMatchTypeEnum = SiteVisitRuleBean.UrlMatchTypeEnum

const formInfoItems: FormDataType[] = [
    FormDataType.Trackers
]

interface Props {
    rules: SiteVisitRuleBean[]
    setRules: (rules: SiteVisitRuleBean[]) => void
}

export const emptySiteVisitRule = (): SiteVisitRuleBean => {
    return {
        trackerId: undefined as any,
        urlMatchType: undefined as any,
        urlPattern: undefined
    }
}

const SiteVisitRules = (props: Props) => {

    const [error, setError] = useState(undefined)
    const [info, setInfo] = useState({
        trackers: []
    })

    const loadData = async () => {
        try {
            const resp = await formDataLoader(...formInfoItems)
            setInfo(resp as any)
        } catch (e) {
            setError(e.error)
        }
    }

    useEffect(() => {
        loadData()
    }, [])

    const setSelectedTracker = (trackerId: number, index: number) => {
        const rule = props.rules[index]
        rule.trackerId = trackerId

        props.setRules([...props.rules])
    }

    const setSelectedMatchType = (urlMatchType: SiteVisitRuleBean.UrlMatchTypeEnum, index: number) => {
        const rule = props.rules[index]
        rule.urlMatchType = urlMatchType

        // urlPattern is ignored for Site
        if (urlMatchType == UrlMatchTypeEnum.Site) {
            rule.urlPattern = undefined
        }

        props.setRules([...props.rules])
    }

    const setUrlPattern = (urlPattern: string, index: number) => {
        const rule = props.rules[index]
        rule.urlPattern = urlPattern

        props.setRules([...props.rules])
    }

    const addRow = () => {
        props.setRules([...props.rules, emptySiteVisitRule()])
    }

    const removeRow = (index: number) => {
        const list = [...props.rules]
        list.splice(index, 1)
        props.setRules(list)
    }

    const renderRules = () => (
        <div className="rule-items">
            {props.rules.length == 0 && <Button title="Add new rule" onClick={addRow}><PlusOutlined /></Button>}
            <div>
                {props.rules.map((rule, index) => <div className="rule-item" key={index}>
                    <Select
                        showSearch
                        optionFilterProp="title"
                        placeholder="Select tracker"
                        value={rule.trackerId}
                        onSelect={value => setSelectedTracker(value, index)}
                        className="rule-selector ant-item-first"
                    >
                        {info.trackers.map((item: TrackerBean) => <Option title={item.name} key={item.id} value={item.id as number}>{item.name}</Option>)}
                    </Select>
                    <Select
                        placeholder="Select match type"
                        value={rule.urlMatchType}
                        onSelect={value => setSelectedMatchType(value, index)}
                        className="rule-selector ant-item-second"
                    >
                        {Object.values(UrlMatchTypeEnum).map(type => <Option key={type} value={type}>{enumView(type)}</Option>)}
                    </Select>
                    <Input
                        placeholder="Url pattern"
                        value={rule.urlPattern}
                        disabled={rule.urlMatchType == UrlMatchTypeEnum.Site}
                        onChange={e => setUrlPattern(e.target.value, index)}
                        className="rule-selector ant-item-second"
                    />
                    <Button title="Remove rule" className="ant-item-second" type="text" onClick={() => removeRow(index)}><MinusOutlined /></Button>
                    {index == props.rules.length - 1 && <Button title="Add new rule" className="ant-item-second" type="text" onClick={addRow}><PlusOutlined /></Button>}
                </div>)}
            </div>
        </div>
    )

    return <FormItem label="Rule list">
        {renderRules()}
    </FormItem>
}

export default SiteVisitRules



// WEBPACK FOOTER //
// ./src/component/app/siteVisitRule/SiteVisitRules.tsx